import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCardModule } from "@angular/material/card";
import { MatTabsModule } from "@angular/material/tabs";
import { PortalModule } from "@angular/cdk/portal";
import { MatBadgeModule } from "@angular/material/badge";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatListModule } from "@angular/material/list";
import { MatRadioModule } from "@angular/material/radio";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatRippleModule } from "@angular/material/core";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatMenuModule } from "@angular/material/menu";
import { OverlayModule } from "@angular/cdk/overlay";
import { ClipboardModule } from "@angular/cdk/clipboard";

@NgModule({
  declarations: [],
  exports: [
    MatCardModule,
    MatIconModule,
    MatChipsModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatTableModule,
    MatSidenavModule,
    MatExpansionModule,
    MatTabsModule,
    MatRadioModule,
    MatBadgeModule,
    MatListModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    PortalModule,
    MatToolbarModule,
    MatRippleModule,
    DragDropModule,
    MatMenuModule,
    OverlayModule,
    ScrollingModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    ClipboardModule,
  ],
})
export class MaterialImportsModule {}
